module.exports = __webpack_public_path__ + "static/cello-2830350_1920_new-3e167983d263f87a1c9d8b7faf845a1d.jpg";